export default {
  title: {
    list: 'Comments',
    edit: 'Update the comment',
  },
  table: {
    route: 'route',
    author: 'climber',
    grade: 'grade',
    tickType: 'ticking',
    liked: 'like',
    createdAt: 'created at',
  },
  form: {
    author: 'Climber',
    tickType: 'Ticking',
    message: 'Message',
    createdAt: 'Created at',
    tickedAt: 'Ticked at',
    grade: 'Grade',
    liked: 'Like',
    variants: 'Variant',
    submit: 'Save',
  },
  delete: {
    button: 'Delete this comment',
    confirm: {
      title: 'Please confirm the deletion of the comment',
      submit: 'Delete',
    },
  },
}
